<template>
  <div class="wrapper">
    <print-content />
  </div>
</template>
<script>
import PrintContent from "./PrintContent.vue";

export default {
  components: {
    PrintContent
  }
};
</script>

<style lang="scss"></style>
